import React from 'react';
import PropTypes from 'prop-types';

const { string } = PropTypes;

const Loading = ({ grid }) =>
<div style={{ background: 'rgb(241, 241, 241)', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column' }}>
    <svg
      width={grid && grid[0] !== 1 ? '100' : '50' }
      height={grid && grid[0] !== 1 ? '100' : '50' }
      viewBox="0 0 250 240"
    >
      <path fill="#efefef" d="M164.9 108.9c-12.7 22-41.3 82.7-65.5 82.7-24.2 0-28.8-41.2-68.3-41.2-10 0-18.5 2.4-27.7 8.8V222c0 7.3 5.9 13.2 13.2 13.2h216.2c7.3 0 13.2-5.9 13.2-13.2V87.8c-19-23.9-43.5-44-81.1 21.1" />
      <path fill="none" stroke="#cecece" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="4" d="M232.8 235.2H16.6c-7.3 0-13.2-5.9-13.2-13.2V18c0-7.3 5.9-13.2 13.2-13.2h216.2c7.3 0 13.2 5.9 13.2 13.2v204c0 7.3-5.9 13.2-13.2 13.2z" />
      <path id="line" fill="none" stroke="#cecece" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="4" d="M246 87.8c-19-23.9-43.5-44-81.1 21-12.7 22-41.3 82.7-65.5 82.7-24.2 0-28.8-41.2-68.3-41.2-10 0-18.5 2.4-27.7 8.8" />
      <circle r="9.5" fill="#fcfcfc" stroke="#cecece" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="4">
        <animateMotion begin="0s" dur="3s" repeatCount="indefinite">
          <mpath xlinkHref="#line"></mpath>
        </animateMotion>
      </circle>
      <circle r="9.5" fill="#fcfcfc" stroke="#cecece" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="4">
        <animateMotion begin=".5s" dur="3s" repeatCount="indefinite">
          <mpath xlinkHref="#line"></mpath>
        </animateMotion>
      </circle>
      <circle r="9.5" fill="#fcfcfc" stroke="#cecece" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" strokeWidth="4">
        <animateMotion begin="1s" dur="3s" repeatCount="indefinite">
          <mpath xlinkHref="#line"></mpath>
        </animateMotion>
      </circle>
    </svg>
    <p style={{ color: 'rgb(136, 136, 136)', fontSize: '16px', fontWeight: '500', paddingTop: '25px', textAlign: 'center' }}>We're crunching some numbers...</p>
  </div>;

Loading.propTypes = {
  svgSize: string,
};

export default Loading;



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/loading.jsx